export default "__VITE_ASSET__DBTywnVr__"